import { NavLink } from "react-router-dom";
import { BarChart3, FileBarChart2, MailOpen, TrendingUp } from "lucide-react";
import { cn } from "@/lib/utils";

const items = [
  { label: "Γενικές", description: "Leads & καμπάνιες", path: "/admin/reports", icon: FileBarChart2, end: true },
  { label: "Συνεργάτες", description: "Απόδοση δικτύου", path: "/admin/reports/partners", icon: TrendingUp },
  { label: "SMS", description: "Παράδοση & clicks", path: "/admin/messages/statistics", icon: BarChart3 },
  { label: "Email", description: "Ανοίγματα & clicks", path: "/admin/email/statistics", icon: MailOpen },
];

export function AdminReportNav() {
  return (
    <nav aria-label="Ενότητες αναφορών">
      <div className="grid grid-cols-2 gap-2 rounded-2xl border border-slate-200/80 bg-white p-2 shadow-[0_1px_2px_rgba(15,23,42,0.03)] md:grid-cols-4">
        {items.map(({ label, description, path, icon: Icon, end }) => (
          <NavLink
            key={path}
            to={path}
            end={end}
            className={({ isActive }) => cn(
              "group flex min-h-[58px] items-center gap-3 rounded-xl px-3 py-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500",
              isActive ? "bg-slate-950 text-white" : "text-slate-600 hover:bg-slate-50 hover:text-slate-950",
            )}
          >
            {({ isActive }) => (
              <>
                <span className={cn(
                  "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg",
                  isActive ? "bg-white/10 text-sky-300" : "bg-slate-100 text-slate-500 group-hover:text-sky-700",
                )}>
                  <Icon className="h-4 w-4" />
                </span>
                <span className="min-w-0 text-left">
                  <span className="block text-sm font-semibold">{label}</span>
                  <span className={cn("block text-[11px]", isActive ? "text-slate-300" : "text-slate-500")}>
                    {description}
                  </span>
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
